query classesSelect($where: ClasseModelFilterInput) {
    data: classes(where: $where, order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}